export const isFunction = (fn: any) => {
    return typeof fn === 'function';
};

export default isFunction;



// WEBPACK FOOTER //
// ./src/utils/isFunction.ts